import { checkDomainAvailability as checkAvailability } from '@wix/ambassador-premium-domains-v2-availability/http';
import { suggestDomains as suggestDomainsAmbassador } from '@wix/ambassador-premium-domains-v2-suggestion/http';
import { createHttpClient } from '@wix/http-client';
import type { CheckDomainAvailabilityResponse } from '@wix/ambassador-premium-domains-v2-availability/types';

const ambassadorHttpClient = createHttpClient({});

export async function checkDomainAvailability(domain: string): Promise<CheckDomainAvailabilityResponse> {
  const response = await ambassadorHttpClient.request(checkAvailability({ domain }));
  return response.data;
}

export async function suggestDomains(query: string): Promise<string[]> {
  const response = await ambassadorHttpClient.request(suggestDomainsAmbassador({ query }));
  return response.data.suggestions.map((suggestion) => suggestion.domain);
}
